module.exports = __webpack_public_path__ + "img/zlecenia_inactive.acf875bd.svg";